import React from "react";
import styles from "@/components/CustomComponents/ProToolBox/index.module.scss";
import ToolCard from "@/components/CustomComponents/ProToolBox/Card";

const ProToolBox = ({ toolBoxData = {} }) => {
  if (!toolBoxData) return null;
  const { heading = "", cards = [] } = toolBoxData;
  return (
    <div className={styles.wrapper}>
      <div className="px-3">
        {heading ? (
          <div className="articleContent">
            <p className="koh-pro-toolbox-title text-xl md:text-3xl text-[#000]">
              {heading}
            </p>
          </div>
        ) : null}
        {cards.map((cardData, index) => (
          <ToolCard key={index} cardData={cardData.fields} />
        ))}
        <hr className=" flex-grow line" />
      </div>
    </div>
  );
};

export default ProToolBox;
